'use client'

import { AnimatePresence, motion } from 'motion/react'
import { IChildrenProps } from '@/typings/children-props'
import {
    getAppearAnimation,
    IGetAppearAnimationParams,
} from '@/utils/animations/get-appear-motion-props'

interface IMotionProps extends IGetAppearAnimationParams, IChildrenProps {
    index?: number
    className?: string
    style?: React.CSSProperties
}

export const Motion = ({ index, className, style, children, ...params }: IMotionProps) => {
    return (
        <AnimatePresence>
            <motion.div
                className={className}
                style={style}
                {...getAppearAnimation(index ?? 0, params)}
            >
                {children}
            </motion.div>
        </AnimatePresence>
    )
}
